// Check if input has only spaces
export const isOnlySpaces = (value: string, errorMsg: string): any => {
  if (value.trim() === '') return errorMsg;
  return null;
};
